import { render, staticRenderFns } from "./form.page.vue?vue&type=template&id=a1b8ce8c&scoped=true"
import script from "./form.page.vue?vue&type=script&lang=ts"
export * from "./form.page.vue?vue&type=script&lang=ts"
import style0 from "./form.page.vue?vue&type=style&index=0&id=a1b8ce8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1b8ce8c",
  null
  
)

export default component.exports